import { useQuery } from '@hooks/reactQuery';

import { getNetworkElementsValidationRulesFolders } from '@api/manageNetworkElementConfigurations';

import { validationIdToOptionsFormatter } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENT_VALIDATION_RULES } from '@constants/queryKeys';

export interface IUseQueryNetworkElementValidationRulesFoldersReturn {
	validationRulesFolders: TSelectOption[];
	isLoadingValidationRulesFolders: boolean;
}

export const useQueryNetworkElementValidationRulesFolders = (): IUseQueryNetworkElementValidationRulesFoldersReturn => {
	const {
		data,
		isFetching,
		isInitialLoading,
	} = useQuery({
		queryKey: [NETWORK_ELEMENT_VALIDATION_RULES],
		queryFn: getNetworkElementsValidationRulesFolders,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		select: validationIdToOptionsFormatter,
		...refetchOptions,
	});

	return {
		validationRulesFolders: data || [],
		isLoadingValidationRulesFolders: isFetching || isInitialLoading,
	};
};

export default useQueryNetworkElementValidationRulesFolders;
